import React from "react"
import BottomBar from "../BottomBar/bottombar"
import "./successKioskCheckIn.css"
import Lottie from "react-lottie"
import { successTick } from "../../animation"
import { useSelector } from "react-redux"
import { RootState } from "store/store"
import { Trans, useTranslation } from "react-i18next"

const SuccessKioskCheckIn = () => {
  const { t } = useTranslation()
  const facilityName = useSelector(
    (state: RootState) => state.facilityReducer.facility?.name || ""
  )

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: successTick,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  }

  return (
    <>
      <div className="success-tick-overview">
        <div className="success-tick">
          <Lottie options={defaultOptions} width="14em" height="14em" />
          <div className="success-tick-message">
            {t("welcome_you_to")} <br />
            {facilityName}!
          </div>
          <div className="success-proceed-text">
            <Trans
              i18nKey="please_proceed_to_waiting_area"
              components={{ newLine: <br /> }}
            />
          </div>
        </div>
        <BottomBar disabled={false} text={t("open_gate")} />
      </div>
    </>
  )
}

export default SuccessKioskCheckIn
